export enum UserUpdateResult {
  Success,
  UserNotFound,
  NotAuthenticated
}
